export const config = [
  { label: 'Accessibility', key: 'accessibility' },
  { label: 'Availability History', key: 'availabilityHistory' },
  { label: 'Availability Stream', key: 'availabilityStream' },
  { label: 'Delivery', key: 'delivery' },
  { label: 'Licensing', key: 'licensing' },
]
